import { useState } from "react";
import TabNav from "../../composants/TabNav/TabNav";
import './Mentions.css';
import PageStatique from "../../composants/PageStatique/PageStatique";

export default function MentionsPage() {
    const [activeTab, setActiveTab] = useState(0);

    const tabs = ["Conditions générales", "Politique de sécurité", "Mentions légales", "Charte RSE", "Charte achat durable", "Charte déontologie"];
    const inactiveTabs: number[] = [];

    const slugs = [
        'conditions-generales',
        'politique-securite',
        'mentions-legales',
        'charte-rse',
        'charte-achat-durable',
        'charte-deontologie',
    ];

    return (
        <div className="mentions-container">
            <h1>Mentions</h1>

            <TabNav
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={(index) => { setActiveTab(index); }}
                inactiveTabs={inactiveTabs}
                inactiveTabsTooltips={{}}
            />

            <div className="mentions-content fullpage">
                <PageStatique slug={slugs[activeTab]} />
            </div>
        </div>
    );
}
